import React, { useState } from 'react'
import { IoPencil } from "react-icons/io5";
import { Link, useParams } from 'react-router-dom';
import { Items } from './Items';

export const MenuCategoriesItem = ({category, onOpenEditCategory, isModifier}) => {
    const [isOpen, setIsOpen] = useState(false);
    const { slug } = useParams();

    const toggleMenuHandler = () => setIsOpen(prev=>!prev);

    return (
        <div className="max-w-full mx-auto mb-4" key={category.id}>
            <div className="shadow overflow-hidden sm:rounded-md">
                <div className="p-3 bg-white relative">
                    <div className="flex justify-between">
                        <div className='flex'>
                            <span className="text-sm font-medium">
                                { isModifier
                                    ? <Link to={`/chain/menu/${slug}/modifiers/${category.id}/edit`}>
                                            <span className="text-indigo-600">{category.name}</span>
                                      </Link>
                                    : category.name}
                            </span>
                        </div>
                        <div className="px-2 flex justify-between items-center">
                           <span onClick={() => onOpenEditCategory(category)}>
                                <IoPencil className="text-indigo-600 cursor-pointer" />
                            </span>
                            <span className="ml-6 cursor-pointer" onClick={toggleMenuHandler}>
                                {isOpen ? (
                                    <img src="/menuicon/arrow_up.svg" alt="arrow_up" width={9} height={12}/>
                                ) : (
                                    <img src="/menuicon/arrow_down.svg" alt="arrow_down" width={9} height={12}/>
                                )}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div className="items mx-5 m-auto">
                {isOpen &&
                    <Items
                        items={isModifier? category.modifier_items : category.dishes}
                        isModifier={isModifier}
                    />}
            </div>
        </div>
  )
}

